package gr.tech.site.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initWemadethelistPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/wemadethelist.md", FrontMatterElement.Builder { addScalar("title", "We Made The List! | Cannabis Business Times 2026 Best Cannabis Companies To Work"); addScalar("description", "We are excited to announce that Green Rebates has been honored by making the 'Cannabis Business Times 2026 Best Cannabis Companies To Work' list!"); addScalar("author", "Ethan Cohen"); addScalar("image", "/images/blog/bestcannabiscompany.png"); addScalar("date", "2026-04-07"); addScalar("updated", "2026-04-07"); }))
}

@Page("/blog/green-rebates-cannabis-business-times-2026-best-cannabis-companies-to-work")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun WemadethelistPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("we-made-the-list") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("We Made The List!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Green Rebates is featured on the Cannabis Business Times 2026 Best Cannabis Companies To Work For list.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The year was 2003. I was in 7th grade, fighting tooth and nail for a spot on my middle school basketball team. Our school was stacked with star athletes who had a knack for making everything look effortless. Sports, girls, popularity, academics, you name it. Little old me spent my time yearning for their validation. Making one of these cool jocks laugh at a dumb joke was the main factor that constituted a good day.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As a basketball player, I didn’t have anywhere near the skills these guys had, but I had something even more important: grit. The type of grit that could grab a rebound over a player taller and stronger than me. The type of grit that got me a spot on the basketball team with the cool kids. Seeing my name on that list was a feeling I didn’t think I’d recapture. That was until a company I work for, Green Rebates, was awarded #13 on the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.cannabisbusinesstimes.com/") {
            org.jetbrains.compose.web.dom.Text("Cannabis Business Times")
        }
        org.jetbrains.compose.web.dom.Text(" 2026 ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.cannabisbusinesstimes.com/top-stories/news/15820817/meet-the-2026-best-cannabis-companies-to-work-for") {
            org.jetbrains.compose.web.dom.Text("Best Cannabis Companies To Work For")
        }
        org.jetbrains.compose.web.dom.Text(" list.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Maybe I’m being a bit dramatic. Maybe nobody cares about this list. But scrolling through this article and seeing our company on the same list as some of the industry’s powerhouses gave us the external validation that feels necessary from time to time. Sure, we live in a world where validation is handed out like lollipops at the dentist’s office, but a recognition like this feels more like the ice cream sundae I had with my dad after making the aforementioned basketball team. This is the kind of validation that takes years of hard work and dedication in silence to achieve. So forgive me for my unnecessary victory speech, but dang it, I feel like one of the cool kids today.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Okay, enough waxing poetic about my middle school basketball achievements. Time to talk about why this award matters.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Finding a job in the cannabis industry is tough. Finding one with a motivating, upbeat work environment is even harder. A company is only as good as its team, and a team is only as good as its culture. Sure, getting over ${'$'}100 million for cultivators across the country is great, but keeping our team happy is an achievement we’re equally proud to share with the world. On every basketball team I made after 7th grade, the culture set by my coach was a direct indicator of our success. When my coach gave us the flexibility to play to our strengths, we grew not only as basketball players, but as humans as well. That’s Dylan Collins’ secret sauce.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dylan doesn’t micromanage. He hires qualified people and gives each one the freedom to let their talents shine bright. Nobody at Green Rebates feels too tied down to the same mundane tasks that make most employees feel stuck in a time loop. Sure, we each have our baseline responsibilities, but we’re also encouraged to pitch grandiose ideas and given the tools to execute them. Last year, I spent hours coming up with rules for a mini-golf tournament at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://mjbizconference.com/") {
            org.jetbrains.compose.web.dom.Text("MJBiz")
        }
        org.jetbrains.compose.web.dom.Text(". Most bosses would view this as a waste of time, but not Dylan - and our company was better for it. That mini-golf tournament was the main attraction at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://mjbizconference.com/") {
            org.jetbrains.compose.web.dom.Text("MJBiz")
        }
        org.jetbrains.compose.web.dom.Text(", providing us with a priceless amount of visibility and recognition at the year’s biggest cannabis event. At Green Rebates, we beautifully blur the line between work and play. Work is play, play is work, and trust is earned.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Oh yeah, we’ve also got a great PTO plan, great benefits, and we take pride in how diverse our team is. With only 11 employees, each team member is given the same trust Phil Jackson gave to his star players during his multiple dynasties.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To learn more about why Green Rebates has been recognized as one of the best places to work in cannabis, ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.cannabisbusinesstimes.com/top-stories/news/15820817/meet-the-2026-best-cannabis-companies-to-work-for#greenrebates") {
            org.jetbrains.compose.web.dom.Text("read the feature here")
        }
        org.jetbrains.compose.web.dom.Text(". Learn all about the benefits, perks, diversity, etc. that helped us make such a prestigious list.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A company that’s built its reputation on getting weed growers paid better have fun while doing so. A big congrats to the other companies, including ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.distru.com/") {
            org.jetbrains.compose.web.dom.Text("distru")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://payrio.co/") {
            org.jetbrains.compose.web.dom.Text("payrio")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.cannavision.com/") {
            org.jetbrains.compose.web.dom.Text("Cannavision Institute")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.theartisttree.com/") {
            org.jetbrains.compose.web.dom.Text("The Artist Tree")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.upstateelevator.com/") {
            org.jetbrains.compose.web.dom.Text("Upstate Elevator Supply Co.")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.paulsboutique.me/") {
            org.jetbrains.compose.web.dom.Text("Paul’s Boutique")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.paragonpayroll.com/") {
            org.jetbrains.compose.web.dom.Text("Paragon Payroll")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenleafbizsolutions.com/") {
            org.jetbrains.compose.web.dom.Text("Green Leaf Business Solutions")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://rovebrand.com/") {
            org.jetbrains.compose.web.dom.Text("Rove")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://theperfectelevation.com/") {
            org.jetbrains.compose.web.dom.Text("Summit")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://steadfastlabs.com/") {
            org.jetbrains.compose.web.dom.Text("Steadfast Labs")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.kccannabis.com/") {
            org.jetbrains.compose.web.dom.Text("Kansas City Cannabis Co.")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://graniteleaf.com/") {
            org.jetbrains.compose.web.dom.Text("GraniteLeaf Cannabis")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.sonoranroots.com/") {
            org.jetbrains.compose.web.dom.Text("Sonoran Roots")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.jardinlasvegas.com/") {
            org.jetbrains.compose.web.dom.Text("Jardín Premium Cannabis Dispensary")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.grasshopperfarms.com/") {
            org.jetbrains.compose.web.dom.Text("Grasshopper Farms")
        }
        org.jetbrains.compose.web.dom.Text(", and ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.velvetcannabis.com/") {
            org.jetbrains.compose.web.dom.Text("Velvet")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Related:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/why-you-should-use-a-rebate-company-for-your-horticulture-energy-rebates-and-incentives") {
                org.jetbrains.compose.web.dom.Text("Why You Should Use A Rebate Company for Your Horticulture Energy Rebates and Incentives")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/green-rebates-wins-prestigious-2024-seal-sustainable-service-award") {
                org.jetbrains.compose.web.dom.Text("Green Rebates Wins Prestigious 2024 Seal Sustainable Service Award")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/the-thc-girls-and-guy-stopped-by-podcast") {
                org.jetbrains.compose.web.dom.Text("The THC Girls (and Guy) Stopped By | Podcast")
            }
        }
    }
}
